// extracted by mini-css-extract-plugin
export default {"div_form":"Form_div_form__SvpyA","input":"Form_input__vWnMs","input_submit":"Form_input_submit__j-z3N"};